import React, { useState } from "react";
import { api } from "@/lib/api";

export const DisconnectModal = ({ onClose, onDone }) => {
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/session/disconnect", null, { headers: { "X-Connect-Token": token } });
      setToken(""); onDone(data.cleared ? "Stored internal session cleared." : "No stored internal session was present — already disconnected.");
    } catch (e) {
      setErr(e.response?.status === 401 ? "Invalid connect token." : (e.response?.data?.detail || "Disconnect failed."));
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="disconnect-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl">
        <h2 className="font-display text-2xl text-stone-900 mb-2">Disconnect internal session</h2>
        <p className="text-sm text-stone-500 mb-4">Removes the stored FUB web session from the Catalog backend. Nothing is changed in Follow Up Boss. Enter the connect token to confirm (it is not stored here).</p>
        <input type="password" autoComplete="off" value={token} onChange={(e) => setToken(e.target.value)}
          data-testid="disconnect-token-input" placeholder="Connect token"
          className="w-full border border-stone-300 rounded-lg px-3 py-2 text-sm mb-3" />
        {err && <div className="text-xs text-rose-700 mb-3" data-testid="disconnect-error">{err}</div>}
        <div className="flex justify-end gap-2">
          <button onClick={onClose} data-testid="disconnect-cancel" className="px-4 py-2 text-sm border border-stone-300 rounded-lg hover:bg-stone-100">Cancel</button>
          <button onClick={submit} disabled={busy || !token} data-testid="disconnect-confirm"
            className="px-4 py-2 text-sm bg-rose-700 text-white rounded-lg hover:bg-rose-600 disabled:opacity-50">Disconnect</button>
        </div>
      </div>
    </div>
  );
};
